import { render } from "./CreditoSimpleOSComponent.vue?vue&type=template&id=2b4be110"
import script from "./CreditoSimpleOSComponent.vue?vue&type=script&lang=js"
export * from "./CreditoSimpleOSComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__